import SqFetch from 'typescript/application/sq_fetch';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';

// functions are controlled by the methods in this controller
// app/controllers/sq/api/carts_controller.rb

export const CART_BASE_URL = '/shop/api/cart';

export type UpdateCartAction = 'add' | 'update' | 'remove';

export interface LineItemAttributes {
  variant_token: string;
  quantity: number;
  add_ons?: string[];
}

export interface UpdateCartRequest {
  update_cart_action: UpdateCartAction;
  line_items_attributes: LineItemAttributes[];
  location_id?: string;
  search_postal_code?: string;
}

export interface UpdateCartResponse {
  success: boolean;
  cart?: Record<string, unknown>;
  errors?: string[];
}

/**
 * Update cart quantity for a line item
 * @param variantToken - the product variant token
 * @param quantity - the quantity to set
 * @param addOnIds - optional array of add-on IDs
 * @param action - the cart action (add, update, remove)
 * @param bopisLocationId - optional BOPIS location ID
 * @param bopisSearchPostalCode - optional BOPIS search postal code
 * @returns response with success status and cart data
 */
export const updateLineItemQuantity = async ({
  variantToken,
  quantity,
  addOnIds,
  action,
  bopisLocationId,
  bopisSearchPostalCode,
}: {
  variantToken: string;
  quantity: number;
  addOnIds?: string[];
  action: UpdateCartAction;
  bopisLocationId?: string;
  bopisSearchPostalCode?: string;
}): Promise<UpdateCartResponse> => {
  const requestBody: UpdateCartRequest = {
    update_cart_action: action,
    line_items_attributes: [
      {
        variant_token: variantToken,
        quantity,
        add_ons: addOnIds,
      },
    ],
  };

  // Add BOPIS parameters if both are provided
  if (bopisLocationId && bopisSearchPostalCode) {
    requestBody.location_id = bopisLocationId;
    requestBody.search_postal_code = bopisSearchPostalCode;
  }

  const response = await SqFetch.put(CART_BASE_URL, requestBody);

  return _handleResponse(response);
};
